import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { add } from 'ionicons/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from '../../route/route.types';
import { DirectConnectMachineAdd } from '../component/direct-connect-machine-add';
import { DirectConnectMachineSelect } from '../component/direct-connect-machine-select';
import { DirectConnectPageHeader } from '../header/direct-connect-page-header';

const DirectConnectSelectMachinePage = () => {
  const { i18n } = useTranslation();

  const [isAddModalShowing, setIsAddModalShowing] = useState(false);

  const page = useRef(null);

  const [presentingElement, setPresentingElement] = useState<
    HTMLElement | undefined
  >(undefined);

  useEffect(() => {
    setPresentingElement(page.current ?? undefined);
  }, []);

  const dismissAddModal = useCallback(() => {
    setIsAddModalShowing(false);
  }, []);

  return (
    <IonPage ref={page}>
      <DirectConnectPageHeader defaultBackRoute={Route.AUTH_LOGIN}>
        <IonTitle>{i18n.t('common:direct_connect_select_robot')}</IonTitle>
      </DirectConnectPageHeader>
      <IonContent>
        <DirectConnectMachineSelect />
        <IonFab slot="fixed" vertical="bottom" horizontal="end">
          <IonFabButton
            onClick={() => {
              setIsAddModalShowing(true);
            }}
          >
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      </IonContent>
      <IonModal
        isOpen={isAddModalShowing}
        onDidDismiss={dismissAddModal}
        presentingElement={presentingElement}
      >
        <IonPage>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={dismissAddModal}>
                  {i18n.t('common:cancel')}
                </IonButton>
              </IonButtons>
              <IonTitle>{i18n.t('common:add_robot')}</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <DirectConnectMachineAdd />
          </IonContent>
        </IonPage>
      </IonModal>
    </IonPage>
  );
};

export { DirectConnectSelectMachinePage };
